import { ButtonSize } from "@components/Button";
import { Card } from "@components/Card";
import { DonateButton } from "@components/layout/DonateButton";
import React from "react";

import { ContextNonprofit } from "src/context/NonprofitsContext/types";
import { spacing } from "src/theme/spacing";

interface DonateDafCardProps {
  nonprofit: ContextNonprofit;
  className?: string;
}
export const DonateDafCard = ({ nonprofit, className }: DonateDafCardProps) => {
  return (
    <Card className={className}>
      <h4>Donate from your Every.org DAF</h4>
      <p>
        You can recommend a grant to this nonprofit from your Every.org donor
        advised fund.
      </p>
      <DonateButton
        css={{
          alignSelf: "flex-end",
          paddingLeft: spacing.xxl,
          paddingRight: spacing.xxl,
        }}
        data-tname="startDonateButton"
        donationsEnabled={nonprofit.donationsEnabled}
        primarySlug={nonprofit.primarySlug}
        size={ButtonSize.MEDIUM}
        toNonprofitPage
      />
    </Card>
  );
};
